module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "SOM",
    attrs: {
      "epub:type": "toc"
    }
  }, [_c('div', {
    staticClass: "enc1"
  }), _vm._v(" "), _c('h1', {
    staticClass: "SOM_titre",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Contents")]), _c('div', {
    staticClass: "enc1"
  }), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre2"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre3"
    }
  }, [_vm._v("Introduction"), _c('br'), _c('span', {
    staticClass: "tabulation"
  }, [_c('i', [_vm._v("Scott M. Manetsch")])])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_part"
  }, [_c('a', {
    attrs: {
      "href": "#/p1"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NE")]), _vm._v(": B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IBLICAL")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTERPRETATION")]), _vm._v(" "), _c('i', [_vm._v("in the")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EFORMATION")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/p1chap1"
    }
  }, [_vm._v("1 “I Have the Word of God”: Scripture, Interpretation,\nand Crespin’s "), _c('i', [_vm._v("History of Martyrs")]), _c('br'), _c('span', {
    staticClass: "tabulation1"
  }, [_c('i', [_vm._v("Scott M. Manetsch")])])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 Martin Luther’s Christological Principle: Implications\nfor Biblical Authority and Biblical Interpretation"), _c('br'), _c('span', {
    staticClass: "tabulation1"
  }, [_c('i', [_vm._v("David S. Dockery")])])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_part"
  }, [_c('span', {
    attrs: {
      "href": "#/p2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("WO")]), _vm._v(": P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REACHING")]), _vm._v(" "), _c('i', [_vm._v("and")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASTORAL")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARE")]), _vm._v(" "), _c('i', [_vm._v("in the")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EFORMATION")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 “Meat, Not Strawberries”: Hugh Latimer and Biblical\nPreaching in the English Reformation"), _c('br'), _c('span', {
    staticClass: "tabulation1"
  }, [_c('i', [_vm._v("Michael A. G. Haykin")])])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 Scripture as “Sacrament” in Protestant Pastoral\nand Devotional Literature"), _c('br'), _c('span', {
    staticClass: "tabulation1"
  }, [_c('i', [_vm._v("Ronald K. Rittgers")])])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_part"
  }, [_c('span', {
    attrs: {
      "href": "#/p3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HREE")]), _vm._v(": J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("USTIFICATION")]), _vm._v(" "), _c('i', [_vm._v("and the")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EFORMATION")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 "), _c('i', [_vm._v("Novum or Rursus?")]), _vm._v(" Justification and the Bible\nin the Reformation"), _c('br'), _c('span', {
    staticClass: "tabulation1"
  }, [_c('i', [_vm._v("Michael S. Horton")])])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 Justification for Today"), _c('br'), _c('span', {
    staticClass: "tabulation1"
  }, [_c('i', [_vm._v("Kevin DeYoung")])])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_part"
  }, [_c('span', {
    attrs: {
      "href": "#/p4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUR")]), _vm._v(": T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRISTIAN")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IFE")]), _vm._v(" "), _c('i', [_vm._v("in the")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EFORMATION")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p4chap1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 The Sainthood of All Believers: The Bible\nand Sanctification"), _c('br'), _c('span', {
    staticClass: "tabulation1"
  }, [_c('i', [_vm._v("Thomas H. McCall")])])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p4chap2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 Luther and the General Priesthood: An Embedded Account"), _c('br'), _c('span', {
    staticClass: "tabulation1"
  }, [_c('i', [_vm._v("David J. Luy")])])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen_autre"
  }, [_c('span', {
    attrs: {
      "href": "#/appen4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Afterword: What Evangelicals Can Learn from the Reformation"), _c('br'), _c('span', {
    staticClass: "tabulation1"
  }, [_c('i', [_vm._v("Timothy George")])])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("List of Contributors")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Author Index")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Subject Index")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scripture Index")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Praise for "), _c('i', [_vm._v("The Reformation and the Irrepressible Word of God")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Editor")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pdf"
  }, [_c('span', {
    attrs: {
      "href": "#/fin_acheve",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Titles from InterVarsity Press")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-029e4e6e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sommaire.vue
// module id = 60
// module chunks = 0